<template>
  <svg width="50" height="51" viewBox="0 0 50 51" xmlns="http://www.w3.org/2000/svg">
    <circle cx="25" cy="25.0273" r="25" :class="[orderStep > 0 ? 'status-active' : 'status-inactive']" />
    <path
      d="M33.5699 12.9579H30.8558V11.7437C30.8558 11.3509 30.4273 11.1724 30.0345 11.1724H27.9275C27.4276 9.74389 26.1777 9.02966 24.7492 9.02966C23.3365 8.97654 22.0515 9.8428 21.5709 11.1724H19.4996C19.1068 11.1724 18.7139 11.3509 18.7139 11.7437V12.9579H15.9998C14.3914 12.9751 13.0756 14.2439 13 15.8505V36.3133C13 37.8846 14.4285 39.0273 15.9998 39.0273H33.5699C35.1412 39.0273 36.5697 37.8846 36.5697 36.3133V15.8506C36.4941 14.2439 35.1783 12.9751 33.5699 12.9579ZM20.1423 12.6008H22.1065C22.4494 12.559 22.7248 12.2982 22.7851 11.958C22.9965 11.037 23.8046 10.3759 24.7492 10.351C25.6851 10.3794 26.481 11.0426 26.6776 11.958C26.7417 12.3099 27.0353 12.5741 27.3919 12.6008H29.4274V15.4578H20.1423V12.6008ZM35.1413 36.3133C35.1413 37.099 34.3556 37.5989 33.5699 37.5989H15.9998C15.2141 37.5989 14.4285 37.099 14.4285 36.3133V15.8506C14.5013 15.0328 15.1789 14.4014 15.9998 14.3864H18.7139V16.2077C18.7516 16.6079 19.0982 16.9072 19.4995 16.8863H30.0344C30.4432 16.9086 30.8006 16.6134 30.8558 16.2077V14.3864H33.5699C34.3907 14.4014 35.0683 15.0327 35.1412 15.8505V36.3133H35.1413Z"
      fill="white" />
    <path
      d="M22.0353 24.9932C21.7674 24.7108 21.3227 24.6949 21.0353 24.9575L18.7498 27.1359L17.7856 26.1359C17.5177 25.8536 17.073 25.8377 16.7856 26.1002C16.509 26.3901 16.509 26.8461 16.7856 27.1359L18.2497 28.6358C18.3765 28.7777 18.5595 28.8562 18.7497 28.8501C18.9381 28.8474 19.1178 28.7704 19.2496 28.6358L22.0351 25.9931C22.3113 25.7398 22.3297 25.3105 22.0764 25.0345C22.0634 25.02 22.0496 25.0063 22.0353 24.9932Z"
      fill="white" />
    <path
      d="M32.2834 26.5283H24.0697C23.6752 26.5283 23.3555 26.8481 23.3555 27.2426C23.3555 27.637 23.6752 27.9568 24.0697 27.9568H32.2834C32.6778 27.9568 32.9976 27.637 32.9976 27.2426C32.9976 26.8481 32.6778 26.5283 32.2834 26.5283Z"
      fill="white" />
    <path
      d="M22.0353 19.2793C21.7674 18.9969 21.3227 18.981 21.0353 19.2436L18.7498 21.422L17.7856 20.4221C17.5177 20.1397 17.073 20.1238 16.7856 20.3864C16.509 20.6762 16.509 21.1322 16.7856 21.422L18.2497 22.9219C18.3765 23.0638 18.5595 23.1423 18.7497 23.1362C18.9381 23.1335 19.1178 23.0565 19.2496 22.9219L22.0351 20.2793C22.3113 20.0259 22.3297 19.5967 22.0764 19.3206C22.0634 19.3062 22.0496 19.2924 22.0353 19.2793Z"
      fill="white" />
    <path
      d="M32.2834 20.8145H24.0697C23.6752 20.8145 23.3555 21.1342 23.3555 21.5287C23.3555 21.9232 23.6752 22.2429 24.0697 22.2429H32.2834C32.6778 22.2429 32.9976 21.9232 32.9976 21.5287C32.9976 21.1342 32.6778 20.8145 32.2834 20.8145Z"
      fill="white" />
    <path
      d="M22.0353 30.707C21.7674 30.4246 21.3227 30.4088 21.0353 30.6713L18.7498 32.8497L17.7856 31.8498C17.5177 31.5674 17.073 31.5515 16.7856 31.8141C16.509 32.1039 16.509 32.5599 16.7856 32.8497L18.2497 34.3496C18.3765 34.4915 18.5595 34.57 18.7497 34.5639C18.9381 34.5612 19.1178 34.4842 19.2496 34.3496L22.0351 31.707C22.3113 31.4537 22.3297 31.0244 22.0764 30.7483C22.0634 30.7339 22.0496 30.7202 22.0353 30.707Z"
      fill="white" />
    <path
      d="M32.2834 32.2422H24.0697C23.6752 32.2422 23.3555 32.5619 23.3555 32.9564C23.3555 33.3509 23.6752 33.6707 24.0697 33.6707H32.2834C32.6778 33.6707 32.9976 33.3509 32.9976 32.9564C32.9976 32.5619 32.6778 32.2422 32.2834 32.2422Z"
      fill="white" />
  </svg>

</template>

<script>
export default {
  name: "statusReceived",
  props: {
    orderStep: Number
  }
};
</script>

<style scoped>
.status-active {
  fill: var(--v-secondary-base);
}

.status-inactive {
  fill: #dbdbdb;
}
</style>
